module.exports = __webpack_public_path__ + "img/help.bd2797c8.svg";